const NativeResizeObserver = window.ResizeObserver;

// MUI's auto-sizing textarea (and similar components) set an element's height
// from inside their own ResizeObserver callback. The browser cannot then
// deliver every observation within the same frame and reports "ResizeObserver
// loop completed with undelivered notifications" as an uncaught error, which
// the dev-server overlay shows as a crash. Running the callbacks on the next
// frame lets each write settle before the next round of observations.
if (NativeResizeObserver) {
  const DeferredResizeObserver = function (callback: ResizeObserverCallback) {
    return new NativeResizeObserver((entries, observer) => {
      window.requestAnimationFrame(() => callback(entries, observer));
    });
  };

  DeferredResizeObserver.prototype = NativeResizeObserver.prototype;
  window.ResizeObserver = DeferredResizeObserver as unknown as typeof ResizeObserver;
}

export {};
